// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file knop/ui/v1/model/track_occupation.proto (package knop.ui.v1.model, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ShuntingUnit } from "./shunting_unit_pb.js";
import { Action } from "./action_pb.js";

/**
 * @generated from message knop.ui.v1.model.TrackOccupation
 */
export class TrackOccupation extends Message<TrackOccupation> {
  /**
   * @generated from field: google.protobuf.Timestamp start_time = 1;
   */
  startTime?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_time = 2;
   */
  endTime?: Timestamp;

  /**
   * @generated from field: int32 order = 3;
   */
  order = 0;

  /**
   * @generated from field: knop.ui.v1.model.ShuntingUnit shunting_unit = 4;
   */
  shuntingUnit?: ShuntingUnit;

  /**
   * @generated from field: repeated knop.ui.v1.model.Action actions = 5;
   */
  actions: Action[] = [];

  /**
   * @generated from field: string arrives_as = 6;
   */
  arrivesAs = "";

  /**
   * @generated from field: string departs_as = 7;
   */
  departsAs = "";

  /**
   * @generated from field: knop.ui.v1.model.TrackOccupation.Interaction originates_from = 8;
   */
  originatesFrom = TrackOccupation_Interaction.INTERACTION_UNKNOWN;

  /**
   * @generated from field: knop.ui.v1.model.TrackOccupation.Interaction dissipates_into = 9;
   */
  dissipatesInto = TrackOccupation_Interaction.INTERACTION_UNKNOWN;

  /**
   * @generated from field: knop.ui.v1.model.TrackOccupation.TrackGroupDrawDirection track_group_draw_direction = 10;
   */
  trackGroupDrawDirection = TrackOccupation_TrackGroupDrawDirection.DIRECTION_UNKNOWN;

  constructor(data?: PartialMessage<TrackOccupation>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "knop.ui.v1.model.TrackOccupation";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "start_time", kind: "message", T: Timestamp },
    { no: 2, name: "end_time", kind: "message", T: Timestamp },
    { no: 3, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "shunting_unit", kind: "message", T: ShuntingUnit },
    { no: 5, name: "actions", kind: "message", T: Action, repeated: true },
    { no: 6, name: "arrives_as", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "departs_as", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "originates_from", kind: "enum", T: proto3.getEnumType(TrackOccupation_Interaction) },
    { no: 9, name: "dissipates_into", kind: "enum", T: proto3.getEnumType(TrackOccupation_Interaction) },
    { no: 10, name: "track_group_draw_direction", kind: "enum", T: proto3.getEnumType(TrackOccupation_TrackGroupDrawDirection) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): TrackOccupation {
    return new TrackOccupation().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): TrackOccupation {
    return new TrackOccupation().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): TrackOccupation {
    return new TrackOccupation().fromJsonString(jsonString, options);
  }

  static equals(a: TrackOccupation | PlainMessage<TrackOccupation> | undefined, b: TrackOccupation | PlainMessage<TrackOccupation> | undefined): boolean {
    return proto3.util.equals(TrackOccupation, a, b);
  }
}

/**
 * @generated from enum knop.ui.v1.model.TrackOccupation.Interaction
 */
export enum TrackOccupation_Interaction {
  /**
   * @generated from enum value: INTERACTION_UNKNOWN = 0;
   */
  INTERACTION_UNKNOWN = 0,

  /**
   * @generated from enum value: MOVE_SOURCE_SIDE = 1;
   */
  MOVE_SOURCE_SIDE = 1,

  /**
   * @generated from enum value: MOVE_TARGET_SIDE = 2;
   */
  MOVE_TARGET_SIDE = 2,

  /**
   * @generated from enum value: SPLIT = 3;
   */
  SPLIT = 3,

  /**
   * @generated from enum value: COMBINE = 4;
   */
  COMBINE = 4,

  /**
   * @generated from enum value: PRESENT_AT_EDGE_OF_SCENARIO = 5;
   */
  PRESENT_AT_EDGE_OF_SCENARIO = 5,

  /**
   * @generated from enum value: TELEPORT = 6;
   */
  TELEPORT = 6,
}
// Retrieve enum metadata with: proto3.getEnumType(TrackOccupation_Interaction)
proto3.util.setEnumType(TrackOccupation_Interaction, "knop.ui.v1.model.TrackOccupation.Interaction", [
  { no: 0, name: "INTERACTION_UNKNOWN" },
  { no: 1, name: "MOVE_SOURCE_SIDE" },
  { no: 2, name: "MOVE_TARGET_SIDE" },
  { no: 3, name: "SPLIT" },
  { no: 4, name: "COMBINE" },
  { no: 5, name: "PRESENT_AT_EDGE_OF_SCENARIO" },
  { no: 6, name: "TELEPORT" },
]);

/**
 * @generated from enum knop.ui.v1.model.TrackOccupation.TrackGroupDrawDirection
 */
export enum TrackOccupation_TrackGroupDrawDirection {
  /**
   * @generated from enum value: DIRECTION_UNKNOWN = 0;
   */
  DIRECTION_UNKNOWN = 0,

  /**
   * @generated from enum value: UP = 1;
   */
  UP = 1,

  /**
   * @generated from enum value: DOWN = 2;
   */
  DOWN = 2,

  /**
   * @generated from enum value: BOTH = 3;
   */
  BOTH = 3,
}
// Retrieve enum metadata with: proto3.getEnumType(TrackOccupation_TrackGroupDrawDirection)
proto3.util.setEnumType(TrackOccupation_TrackGroupDrawDirection, "knop.ui.v1.model.TrackOccupation.TrackGroupDrawDirection", [
  { no: 0, name: "DIRECTION_UNKNOWN" },
  { no: 1, name: "UP" },
  { no: 2, name: "DOWN" },
  { no: 3, name: "BOTH" },
]);

